// extracted by mini-css-extract-plugin
export default {"cartSummaryContainer":"CartSummary-cartSummaryContainer_zHSkZ","cartSummarySubContainer":"CartSummary-cartSummarySubContainer_cus4y","section":"CartSummary-section_qM_dM"};